import React from "react";
import { BrowserRouter, Switch, Route, Redirect} from "react-router-dom";
import Movies from "../pages/Home";
import Login from "../pages/Login";
import Cookies from "js-cookie";
import { UserProvider } from "../Context/UserContext";
import Register from "../pages/Register";
import LayoutComponent from "../layout/LayoutComponent";
import DataGames from "../pages/DataGames";
import DataMovies from "../pages/DataMovies";
import CreateDataGames from "../pages/CreateDataGames";
import CreateDataMovies from "../pages/CreateDataMovies";
import { UsersProvider } from "../Context/UserGames";
import Games from "../pages/Games";
import MovieDetail from "../pages/MoviDetail";
import GameDetail from "../pages/GamesDetail";

const Routes = () => {

    const LoginRoute = ({...props}) => {
        if (Cookies.get('user') === undefined) {
            return <Route {...props} />
        } else if (Cookies.get('user') !== undefined) {
            return <Redirect to="/" />
        }
    }

    return  (
    <BrowserRouter>
     <UsersProvider>
    <UserProvider>
    <Switch>
    <Route path="/" exact> 
        <LayoutComponent content={<Movies/>}/>
    </Route>
    <Route path="/movie/:Id" exact> 
        <LayoutComponent content={<MovieDetail/>}/>
    </Route>
    <Route path="/games" exact> 
        <LayoutComponent content={<Games/>}/>
    </Route>
    <Route path="/game/:Id" exact> 
        <LayoutComponent content={<GameDetail/>}/>
    </Route>
    <LoginRoute path="/login" exact>
     <LayoutComponent content={<Login/>} />    
    </LoginRoute>
    <LoginRoute path="/register" exact >
    <LayoutComponent content={<Register/>} />    
    </LoginRoute>
    <Route path="/data-movies" exact> 
        <LayoutComponent content={<DataMovies/>}/>
    </Route>
    <Route path="/create-data-movies" exact> 
        <LayoutComponent content={<CreateDataMovies/>}/>
    </Route>
    <Route path="/create-data-movies/edit/:Id" exact> 
        <LayoutComponent content={<CreateDataMovies/>}/>
    </Route>
    <Route path="/data-games" exact> 
        <LayoutComponent content={<DataGames/>}/>
    </Route>
    <Route path="/create-data-games" exact> 
        <LayoutComponent content={<CreateDataGames/>}/>
    </Route>
    <Route path="/create-data-games/edit/:Id" exact> 
        <LayoutComponent content={<CreateDataGames/>}/>
    </Route>

    </Switch>
    </UserProvider>
    </UsersProvider>
    </BrowserRouter>
    )

}

export default Routes